import { render, staticRenderFns } from "./expoTable.vue?vue&type=template&id=596cda14&"
import script from "./expoTable.vue?vue&type=script&lang=js&"
export * from "./expoTable.vue?vue&type=script&lang=js&"
import style0 from "./expoTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports